<!-- eslint-disable -->
<template>
  <b-container class="w-50 m-width text-14">
    <h2 class="text-purple text-gotham-bold text-40 pb-4">{{ this.language == 'en' ? 'Package Dropoff' : 'Paket Dropoff' }}</h2>

    <!-- alert failed payment -->
    <div class="card-custom text-red text-12 text-gotham-bold p-3 alert alert-danger"  :class="this.isFailed ? '':'d-none'" style="min-height: 50px;">
      Pembayaran gagal. Silakan periksa saldomu dan coba kembali.
    </div>

    <!-- alert timesout -->
    <div class="card-custom text-yellow text-12 text-gotham-bold p-3 alert alert-warning" :class="this.isTimesOut ? '':'d-none'" style="min-height: 50px;">
      Waktu pembayaran habis. Silakan coba lagi.
    </div>

    <br />
    <div class="card-custom text-center">
      <div class="card-custom-header">
        <div class="row py-3">
          <div class="col text-gotham-book text-left">
            {{ this.language == 'en' ? 'Invoice Number' : 'Nomor Invoice' }}
          </div>
          <div class="col text-gotham-bold text-right">
            {{this.overdueDropOff !== null ?  this.form.invoice_number: 'INV-DOL-XXXXXX-XXXX'}}
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col text-gotham-book text-left">
            <div class="mb-2 mt-2">{{ this.language == 'en' ? 'Order Number' : 'Nomor Order' }}</div>
            <div class="mb-2">{{ this.language == 'en' ? 'Sender' : 'Pengirim' }}</div>
            <div class="mb-2">{{ this.language == 'en' ? 'Time Created' : 'Waktu Dibuat' }}</div>
            <div class="mb-2">{{ this.language == 'en' ? 'Location' : 'Lokasi' }}</div>
            <div class="mb-2">{{ this.language == 'en' ? 'Door Number' : 'Nomor Pintu' }}</div>
          </div>
          <div class="col text-gotham-bold text-right">
            <div class="mb-2 mt-2">{{ this.overdueDropOff !== null ? this.overdueDropOff.expressNumber : '-'}}</div>
            <div class="mb-2">{{ this.overdueDropOff !== null ? this.overdueDropOff.senderName : '-'}}</div>
            <div class="mb-2">{{ this.overdueDropOff !== null ? epochToDateTime(this.overdueDropOff.createTime) : '-'}}</div>
            <div class="mb-2">{{ this.overdueDropOff !== null ? this.overdueDropOff.mouth.box.name : '-'}}</div>
            <div class="mb-2">{{ this.overdueDropOff !== null ? this.overdueDropOff.mouth.number : '-'}}</div>
          </div>
        </div>
      </div>
      <div class="card-custom-footer">
        <div class="row" style="justify-content: center;align-items: center;">
          <div class="col ">
            <div class="text-gotham-med text-left" @click="showDetail()">
              {{this.language == 'en' ? 'Total Payment' : 'Total Pembayaran'}}
            </div>
            <!-- detail -->
            <div class="text-12" :class="isDetail ? '' : 'd-none'">
              <div class="mb-2 mt-2 text-gotham-book text-left">
                {{this.language == 'en' ? 'Overdue price per day' : 'Biaya overdue per hari'}}
              </div>
              <div class="mb-2 text-gotham-book text-left">
                {{this.language == 'en' ? 'Total days' : 'Jumlah hari'}}
              </div>
            </div>
          </div>
          <div class="col">
            <div class="text-gotham-bold text-right text-pointer" @click="showDetail()" style="justify-content: right;display: flex;align-items: center;">
              {{this.overdueDropOff !== null ? formatRupiah(this.overdueDropOff.overdueTotalPrice) : 'Rp. 0'}}
              <img v-if="isDetail" src="@/assets/images/ic-arrow-up.png" style="width:20px">
              <img v-else src="@/assets/images/ic-arrow-down.png" style="width:20px">
            </div>
            <!-- detail -->
            <div class="text-12" :class="isDetail ? '' : 'd-none'">
              <div class="mb-2 mt-2 text-gotham-book text-right">
                {{ this.overdueDropOff !== null ? formatRupiah(this.overdueDropOff.overdueBasePrice) : 'Rp. 0'}}
              </div>
              <div class="mb-2 text-gotham-book text-right">
                {{this.overdueDropOff !== null ? this.overdueDropOff.overdueDays : '-'}}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="card text-center text-black text-12 p-3 alert alert-warning" :class="isDetail ? '' : 'd-none'" style="min-height: 50px;">
              {{ this.language == 'en'? 'The final price will be displayed when selecting payment':'Harga final akan ditampilkan saat memilih pembayaran.'}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <label class="text-18 text-gotham-bold py-2">{{this.language == 'en' ? 'Receiver Detail' : 'Detail Penerima'}}</label>
    <div class="group-1 custom-group">
      <b-form-group class="text-gotham-med text-left" style="margin-bottom: 0px!important;">
        <div>
          <div class="input-group custom-input-group">
            <!-- Icon on the left (image) -->
            <div class="input-group-prepend ">
              <span class="input-group-text icon-prepend" style="border-top-left-radius: 0.5rem !important;background-color: #FAFAFA !important;">
                <img src="@/assets/icons/ic_name.svg" alt="icon" class="icon-image" />
              </span>
            </div>
            <!-- b-form-input for the input field -->
            <b-form-input v-model.trim="form.receiver_name" type="text" :placeholder="this.language == 'en' ? 'input receiver name' : 'masukan nama penerima'"
              class="text-gotham-book custom-input no-focus-border" style="border-top-right-radius: 0.5rem !important;background-color: #FAFAFA !important;" :class="isValid.receiver_name ? '' : 'is-invalid'" readonly st></b-form-input>
          </div>
          <b-form-invalid-feedback v-if="this.language == 'en'">
            {{ isValid.receiver_name ? '' : 'Receiver name cannot be empty' }}
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-else>
            {{ isValid.receiver_name ? '' : 'Nama penerima tidak boleh kosong' }}
          </b-form-invalid-feedback>
        </div>
      </b-form-group>
      <b-form-group class="text-gotham-med text-left" style="margin-bottom: 0px!important;">
        <div>
          <div class="input-group custom-input-group">
            <!-- Icon on the left (image) -->
            <div class="input-group-prepend">
              <span class="input-group-text icon-prepend middle-input" style="background-color: #FAFAFA !important;">
                <img src="@/assets/icons/ic_phone.svg" alt="icon" class="icon-image" />
              </span>
            </div>
            <!-- b-form-input for the input field -->
            <b-form-input v-model.trim="form.receiver_contact" type="text" :placeholder="this.language == 'en' ? 'input phone number' : 'masukan nomor telepon'"
              class="text-gotham-book custom-input no-focus-border" @input="enforcePhoneNumber"
              :class="isValid.receiver_contact ? '' : 'is-invalid'" readonly style="background-color: #FAFAFA !important;"></b-form-input>
          </div>
          <b-form-invalid-feedback v-if="this.language == 'en'">
            {{ isValid.receiver_contact ? '' : 'Phone number cannot be empty' }}
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-else>
            {{ isValid.receiver_contact ? '' : 'Nomor telepon tidak boleh kosong' }}
          </b-form-invalid-feedback>
        </div>
      </b-form-group>
      <b-form-group class="text-gotham-med text-left" style="margin-bottom: 0px!important;" >
        <div>
          <div class="input-group custom-input-group">
            <!-- Icon on the left (image) -->
            <div class="input-group-prepend">
              <span class="input-group-text icon-prepend  last-input" style="border-bottom-left-radius: 0.5rem !important;background-color: #FFF !important;">
                <img src="@/assets/icons/ic_mail.svg" alt="icon" class="icon-image" />
              </span>
            </div>
            <!-- b-form-input for the input field -->
            <b-form-input v-model.trim="form.email_address" type="email" :placeholder="this.language == 'en' ? 'Email address*' : 'Email penerima*'"
              class="text-gotham-book custom-input no-focus-border" :class="isValid.email_address ? '' : 'is-invalid'" style="border-bottom-right-radius: 0.5rem !important;">
            </b-form-input>
          </div>
          <b-form-invalid-feedback v-if="this.language == 'en'">
            {{ emailIsEmpty ? '' : 'Email is not valid' }}
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-else>
            {{ emailIsEmpty ? '' : 'Email tidak valid' }}
          </b-form-invalid-feedback>
        </div>
      </b-form-group>
    </div>
    <br />
    <div class="pb-4"></div>
    <template>
			<div class="text-center mx-6"
				:style="{
					background: 'white',
					position: 'sticky',
					bottom: '0',
					margin: '0 -1.5rem',
					padding: '0 1.5rem',
					marginBottom: '-1.5rem',
					paddingBottom: '1.5rem',
				}"
			>
        <div @click="validSubmit ? payOverdue() : null"
          class="btn-block btn-lg text-gotham-med text-center text-white text-14"
          :class="validSubmit ? 'bg-purple-paxel btn-payment-enable text-pointer' : 'bg-gray btn-payment-disable'">
          <loadingCircle v-if="loadingPayment" />
          <span v-else>{{this.language == 'en' ? 'Select Payment' : 'Pilih Pembayaran'}}</span>
        </div>
			</div>
		</template>
  </b-container>
</template>
<script>
/* eslint-disable */

import i18n from '@/plugins/i18n';
import loadingCircle from "@/views/reuse/loadingCircle.vue";
import LocalStorage from '@/services/localstorage';

export default {
  components: { loadingCircle },
  data() {
    return {
      form: {
        receiver_name: '',
        receiver_contact: '',
        email_address: '',
        invoice_number: '',
      },
      isValid: {
        receiver_name: true,
        receiver_contact: true,
        email_address: true,
      },
      detail: false,
      loading: false,
      minPhoneLength: 8,
      maxPhoneLength: 13,
      isFailed: false,
      isTimesOut: false,
      paxelboxBaseUrl: process.env.VUE_APP_PAXELBOX_BASE_URL,
      loadingPayment: false,
    };
  },
  beforeMount() {
    // checking query paramater overduepayment
    this.validateUser()
    this.$store.dispatch("getSettings")
    const paramOrderId = this.$route.query.orderid;
    if (paramOrderId !== undefined) {
      this.$store.dispatch('getOverdueDropoffDetail', paramOrderId)
        .then((response) => {
            const { overdueStatus, status } = response;

          if (response.id) {
            const { overdueStatus, status } = response;
            if (status === 'IN_STORE') {
              // status: in store
              switch (overdueStatus) {
                case 'none':
                  this.redirectToDetail();
                  break;
                case 'expired':
                  this.redirectOverdue('expire');
                  break;
                default:
                  // this form overdue
                  break;
              }
            } else {
              // status: not in store
              this.redirectToDetail();
            }
            this.form.receiver_name = this.overdueDropOff.recipientName;
            this.form.receiver_contact = this.overdueDropOff.takeUserPhoneNumber;
            this.form.invoice_number = this.generateID();

            // handle query param orderid and status
            const paramStatus = this.$route.query.status;
            if (paramOrderId !== undefined && paramOrderId.length !== 0) {
              if (paramStatus === 'cancel') {
                this.isTimesOut = true;
              } else if (paramStatus === 'failed') {
                this.isFailed = true;
              }
            }
          }
        })
        .catch(() => {
          this.redirectToPaxelbox();
        });
    } else {
      this.redirectToPaxelbox();
    }
  },
  // mounted() {
  //   if (this.overdueDropOff !== null) {
  //     this.form.receiver_name = this.overdueDropOff.recipientName;
  //     this.form.receiver_contact = this.overdueDropOff.takeUserPhoneNumber;
  //     this.form.invoice_number = this.generateID();

  //     // handle query param orderid and status
  //     const paramOrderId = this.$route.query.orderid;
  //     const paramStatus = this.$route.query.status;
  //     if (paramOrderId !== undefined && paramOrderId.length !== 0) {
  //       if (paramStatus === 'cancel') {
  //         this.isTimesOut = true;
  //       } else if (paramStatus === 'failed') {
  //         this.isFailed = true;
  //       }
  //     }
  //   } else {
  //     this.redirectToPaxelbox();
  //   }
  // },
  computed: {
    receiveNameIsEmpty() {
      return !(this.form.receiver_name.length > 0);
    },
    receiveContactIsEmpty() {
      return !(this.form.receiver_contact.length > 0);
    },
    emailIsEmpty() {
      const email = this.form.email_address.trim();
      if (!email || email.length === 0) {
        return false;
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const result = emailRegex.test(email);
      return result;
    },
    validSubmit() {
      return (!this.receiveNameIsEmpty && !this.receiveContactIsEmpty && this.emailIsEmpty);
    },
    isDetail() {
      return this.detail;
    },
    overdueDropOff() {
      return this.$store.state.overdueDropOffDetail;
    },
  },
  methods: {
    enforcePhoneNumber(value) {
      this.$nextTick(() => {
        this.form.receiver_contact = value.replace(/\D/g, '');
      });
    },
    async payOverdue(){
      let settings = this.$store.getters.getSettings;
      if(!settings){
        await this.$store.dispatch("getSettings")
      }
      let snap_bi_features = this.getSettingValue("enabled_userapp_feature","snap_bi_dropoff")
      this.loadingPayment = true;
      if(snap_bi_features?.value == 'enabled'){
        this.payViaSnapBI();
      }else{
        this.payNonSnapBI();
      }
    },
    payNonSnapBI() {
      if (this.overdueDropOff !== null) {
        this.loadingPayment = true;
        const data = {
          orderId: this.overdueDropOff.id,
          formdata: {
            email: this.form.email_address,
            invoice_number: this.form.invoice_number,
            overdue_time: this.overdueDropOff.overdueTime,
            overdue_days: this.overdueDropOff.overdueDays,
            overdue_total_price: this.overdueDropOff.overdueTotalPrice,
          },
        };
        this.$store.dispatch('sendOverdueDropoff', data)
          .then((response) => {
            const responseData = response.data;
            if (responseData.code === 200) {
              // call api generate token payment
              this.$store.dispatch('getTokenPayment').then((responseToken) => {
                const accessToken = responseToken.data.access_token;
                let url = window.location.origin+"/order?orderid="+this.overdueDropOff.id
                const dataCreatePayment = {
                  token: accessToken,
                  formdata: {
                    client: 'overdue_dropoff_locker',
                    email: this.form.email_address,
                    invoice_number: this.form.invoice_number,
                    cashier_name: this.form.receiver_name,
                    phone_number: this.form.receiver_contact,
                    success_url: `${url}&payment_status=SUCCESS`,
                    failed_url: `${this.paxelboxBaseUrl}/overduepayment?orderid=${this.overdueDropOff.id}&status=failed`,
                    cancel_url: `${this.paxelboxBaseUrl}/overduepayment?orderid=${this.overdueDropOff.id}&status=cancel`,
                    locker_order_type: 'Drop Off',
                    order_info: [{
                      order_id: this.overdueDropOff.expressNumber,
                      name: this.form.receiver_name,
                      box_id: this.overdueDropOff.mouth.box.id,
                      door_number: this.overdueDropOff.mouth.number,
                      box_name: this.overdueDropOff.mouth.box.name,
                      size: this.overdueDropOff.mouth.mouthType.name,
                      localization: 'indonesia',
                      duration: this.overdueDropOff.overdueDays,
                      price: this.overdueDropOff.overdueTotalPrice,
                      currency: 'Rp',
                      payment_type: 'extention',
                    }],
                  },
                };
                // call api create payment
                this.$store.dispatch('createPayment', dataCreatePayment).then((responseCreate) => {
                  this.loadingPayment = false;
                  this.redirectToPayment(responseCreate.payment_url);
                });
              });
            }else{
              this.loadingPayment = false;
            }
          })
          .catch((error) => {
            this.loadingPayment = false;
            const message = error.response.data.message || i18n.t('something_wrong');
            this.$swal({
              icon: 'error',
              title: 'Oops...',
              text: message,
            });
          });
      }
    },
    showDetail() {
      this.detail = !this.detail;
    },
    redirectToPaxelbox() {
      this.$router.push({ path: '/' });
    },
    redirectToPayment(url) {
      window.location.href = url;
    },
    redirectOverdue(page) {
      let urlPage = '/';
      if (page === 'success') {
        urlPage = '/overduepayment/success';
      } else if (page === 'expire') {
        urlPage = '/overduepayment/expire';
      } else if (page === 'success-payment') {
        urlPage = '/overduepayment/success-payment';
      }
      this.$router
        .push({ path: urlPage })
        .then(() => { this.$router.go(); });
    },
    validateUser() {
      let data_payload = {
        "token": this.$route.query.token
      }
      if (this.$route.query.token){
        this.$store.dispatch("validateUser", data_payload)
      }
    },
    redirectToDetail(){
      this.$router
        .push({ path: `/order?orderid=${this.overdueDropOff.id}`})
        .then(() => { this.$router.go(); });
    },
    payViaSnapBI(){
      const paramOrderId = this.$route.query.orderid;
      let url = window.location.origin+"/order?orderid="+paramOrderId
      let token = this.$route.query.token?this.$route.query.token:LocalStorage.getUserToken()
      if(token){
        url = url+"&token="+token
      }
      /// overdue 
      let userdata = JSON.parse(LocalStorage.getUserData())
      const payload = {
        order_id: this.overdueDropOff.id,
        order_number : this.overdueDropOff.expressNumber,
        email: this.form.email_address,
        invoice_number: this.form.invoice_number,
        overdue_time: this.overdueDropOff.overdueTime,
        overdue_days: this.overdueDropOff.overdueDays,
        overdue_total_price: this.overdueDropOff.overdueTotalPrice,
        recipient_name : this.form.receiver_name,
        phone : this.form.receiver_contact,
        url_param : url,
        language : this.language
      };
      this.$store.dispatch('payOverdueDropoffSnapBi',payload).then((data) => {
        window.location.href = data.data.checkout_url
      }).catch((error) => {
        this.loadingPayment = false;
        const message = error.response.data.message || i18n.t('something_wrong');
        this.$swal({
          icon: 'error',
          title: 'Oops...',
          text: message,
        });
      });
    },
  },
};
</script>
<style>
.bg-purple-paxel,
.btn-payment-enable:focus,
.btn-payment-enable:hover {
  background-color: #5F51A1;
  outline: none;
  box-shadow: none;
}

.bg-gray,
.btn-payment-disable:focus,
.btn-payment-disable:hover {
  background-color: #C4C7CA;
  outline: none;
  box-shadow: none;
}

.bg-gray-light {
  background-color: #f0f0f6;
  outline: none;
  box-shadow: none;
}

.text-purple {
  color: #5F51A1;
}

.text-black {
  color: #424143;
}

.text-red {
  color: #FF434F;
}

.text-yellow {
  color: #F5A623;
}

.text-gotham-bold {
  font-family: "GothamBold";
}

.text-gotham-med {
  font-family: "GothamMedium";
}

.text-gotham-book {
  font-family: "GothamBook";
}

.text-10 {
  font-size: 10px;
}

.text-12 {
  font-size: 12px;
}

.text-14 {
  font-size: 14px;
}

.text-18 {
  font-size: 18px;
}

.text-24 {
  font-size: 24px;
}

.text-21 {
  font-size: 21px;
}

.text-40 {
  font-size: 40px;
}

.text-weight-700 {
  font-weight: 700;
}

.text-weight-500 {
  font-weight: 500;
}

.m-width {
  min-width: 400px;
}
@media (max-width: 400px) {
  .m-width {
    min-width: auto;
    width: 100% !important;
  }
}
.text-pointer {
  cursor: pointer;
}

.bg-form {
  background: url("../../../assets/images/bg-cityscape.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.h-bg-form-desktop {
  height: 200px;
}

.h-bg-form-mobile {
  height: 100px;
}

.card-custom{
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #FAFAFA !important;
  background-clip: border-box;
  border: 1px solid #EBEAF3;
  border-radius: 0.25rem;
}
.card-custom-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  border-bottom: 1px solid #EBEAF3;
}
.card-custom-footer{
  padding: 0.75rem 1.25rem;
  background-color: #FAFAFA !important;
  border-top: 1px solid #EBEAF3;
}
/* Remove right border from image section */
.icon-prepend {
  border-right: none !important;
  padding-left: 0.5rem; /* Adjust padding for image spacing */
  padding-right: 0.5rem;
  border-radius: 0 !important;
}

/* Adjust the image size */
.icon-image {
  width: 24px;
  height: 24px;
}

/* Remove left border from input field */
.custom-input {
  border-left: none !important;
}
/* Disable the border on focus */
.no-focus-border:focus {
  /* outline: none !important; */
  box-shadow: none !important;
  border-color: #ced4da; /* Removes border on focus */
}
.group-1 .form-control {
  border-radius: 0 !important;
}

/* Remove border-radius from the middle input */
.middle-input {
  border-radius: 0 !important;
}
</style>
